/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SurveyDto } from '../../models/survey-dto';

export interface SurveyControllerDelete$Params {
  id: string;
}

export function surveyControllerDelete(http: HttpClient, rootUrl: string, params: SurveyControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyDto>> {
  const rb = new RequestBuilder(rootUrl, surveyControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SurveyDto>;
    })
  );
}

surveyControllerDelete.PATH = '/api/survey/{id}';
